import React, { memo } from 'react';
import './starrybackground.css';

// Pre-generate stars for consistent rendering
const STATIC_STARS = Array.from({ length: 200 }, (_, i) => ({
  id: i,
  x: Math.random() * 100,
  y: Math.random() * 100,
  size: Math.random() * 2 + 1,
  opacity: Math.random() * 0.5 + 0.3,
  animationDuration: Math.random() * 3 + 2,
}));

const StarryBackground: React.FC = () => {
  return (
    <div className="starry-background">
      <div className="stars-container">
        {STATIC_STARS.map((star) => (
          <div
            key={star.id}
            className="star"
            style={{
              left: `${star.x}%`,
              top: `${star.y}%`,
              width: `${star.size}px`,
              height: `${star.size}px`,
              '--opacity': star.opacity,
              '--animation-duration': `${star.animationDuration}s`,
            } as React.CSSProperties}
          />
        ))}
      </div>
      <div className="shooting-star"></div>
      <div className="shooting-star"></div>
      <div className="shooting-star"></div>
    </div>
  );
};

export default memo(StarryBackground);
